import { useMemo } from 'react'
import { AuthTokenStorage } from '../../types'

export const useStorageAdapter = (storage: Storage, key: string): AuthTokenStorage => (
  useMemo<AuthTokenStorage>(() => ({
    get: () => storage.getItem(key),
    set: (value) => {
      if (value) {
        storage.setItem(key, value)
      } else {
        storage.removeItem(key)
      }
    },
  }), [storage, key])
)
